// Svelte 5 no longer needs svelte/store imports for basic reactivity

// Create reactive state for authentication as an object that can be mutated
export const authState = $state({});

// Function to reset authentication state
export function resetAuth() {
    // Instead of reassigning authState, clear its properties
    authState.user = null;
    authState.team = null;
}

// Function to update team information
export function updateTeam(teamInfo) {
    authState.team = teamInfo;
}

// Function to update user information
export function updateUser(userInfo) {
    authState.user = userInfo;
}

// Function to set entire auth state
export function setAuth(auth) {
    // Update properties individually instead of reassigning
    Object.keys(auth).forEach(key => {
        authState[key] = auth[key];
    });
}

// Add getter functions if needed
export function getAuthState() {
    return authState;
}